module.exports = __webpack_public_path__ + "img/img20.a135ded6.png";